const Builder = require('../BuilderBase');

module.exports = class LineBreakColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_LineBreak', title, properties);
    }
};
